import React from "react";
import "./Officecleanouts.css";
import { FiTrash } from "react-icons/fi";
import junk from "../../Assests/service2.webp";

const Officecleanouts = () => {
  return (
    <section className="Officecleanouts-section">
      <div className="Officecleanouts-container">
        {/* Content Column */}
        <div className="Officecleanouts-content">
          <div className="content-header">
            <div className="service-icons">
              <FiTrash size={32} />
            </div>
            <h1 className="service-title">
              <span className="title-accent">Yard </span> Debris Removal
            </h1>
          </div>

          <p className="service-description">
            Clearing yard waste can be exhausting—our debris removal service makes it simple.
            From branches and brush to old fencing and garden clutter, we’ll handle the lifting,
            hauling, and proper disposal so you can enjoy your outdoor space again. We arrive on
            schedule, work efficiently, and leave no mess behind.
          </p>

          <p className="service-description">
            Materials are disposed of responsibly, with recycling or composting whenever possible.
            We take green waste, fencing, outdoor junk, storm debris, and small loads of soil or gravel—removing
            the hassle from your cleanup project. Our friendly team ensures the process is stress-free
            from start to finish. With us, your yard will look refreshed, safe, and ready to use again.
          </p>

          <div className="cta-group">
            <a
              href="https://app.squareup.com/appointments/book/41vplmwf0luh01/LTHMTFD90TMRT/start"
              className="primary-cta"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Your Pickup
              <span className="cta-arrow">→</span>
            </a>
          </div>
        </div>

        {/* Image Column */}
        <div className="Officecleanouts-image">
          <img
            src={junk}
            alt="Professional team handling yard debris removal"
            className="main-image"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default Officecleanouts;
